import { formatToBRL } from "@/utils/formatToMoney";
import { AlertTriangle } from "lucide-react";

interface NsuRejectedWarningProps {
  rejectedNsus: Array<{
    id: number;
    number: string;
    amount: number;
  }>;
}

export function NsuRejectedWarning({ rejectedNsus }: NsuRejectedWarningProps) {
  if (rejectedNsus.length === 0) return null;

  return (
    <div className="w-full mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-amber-800 mb-2">
            NSUs Rejeitados pelo Administrador
          </h3>
          <div className="space-y-2">
            {rejectedNsus.map((nsu) => (
              <div key={nsu.id} className="text-sm text-amber-700">
                <span className="font-medium">• NSU: {nsu.number || 'Sem número'}</span>
                <span className="ml-2 text-amber-600">
                  ({formatToBRL(nsu.amount)})
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
